var _circle, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFNftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.1235,
    cy: 10.7204,
    r: 10,
    fill: "#232156"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.63439 9.45613L3.05011 9.66779C3.22616 9.75753 3.43678 9.75753 3.61283 9.66779L9.22323 6.81387C9.64486 6.59965 10.1488 6.59965 10.5704 6.81387L16.2338 9.67361C16.4089 9.76212 16.6178 9.76212 16.7929 9.67361L17.2171 9.45613C17.3163 9.40561 17.3784 9.30623 17.3784 9.19796C17.3784 9.08968 17.3163 8.9903 17.2171 8.93978L10.568 5.58694C10.1464 5.37271 9.64245 5.37271 9.22082 5.58694L2.63439 8.94326C2.53704 8.99436 2.47644 9.09275 2.47644 9.1997C2.47644 9.30665 2.53704 9.40504 2.63439 9.45613Z",
    fill: "url(#paint0_linear_382_2516)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6446 14.1772L16.2341 11.2186C16.4111 11.1273 16.6216 11.1295 16.7966 11.2246L17.2169 11.4455C17.3162 11.4976 17.3784 11.6006 17.3784 11.7129C17.3784 11.8252 17.3162 11.9282 17.2169 11.9803L10.647 15.4556C10.2256 15.678 9.72196 15.678 9.30054 15.4556L2.63792 11.9585C2.53865 11.9065 2.47644 11.8034 2.47644 11.6911C2.47644 11.5788 2.53865 11.4758 2.63792 11.4238L9.2078 7.94601C9.62922 7.72365 10.1329 7.72365 10.5543 7.94601L14.7913 10.1623C14.8905 10.2148 14.9525 10.3179 14.9525 10.4303C14.9525 10.5427 14.8905 10.6458 14.7913 10.6983L10.576 12.9061C10.1542 13.1289 9.65002 13.1289 9.22828 12.9061L6.01741 11.2053C5.84112 11.1117 5.63004 11.1117 5.45376 11.2053L5.05029 11.4189C4.95112 11.4714 4.88905 11.5745 4.88905 11.6869C4.88905 11.7993 4.95112 11.9025 5.05029 11.9549L9.29813 14.1772C9.71955 14.3996 10.2232 14.3996 10.6446 14.1772ZM9.22105 9.22436L7.45303 10.1599C7.35439 10.2122 7.29269 10.3148 7.29269 10.4267C7.29269 10.5385 7.35439 10.6412 7.45303 10.6934L9.23189 11.6386C9.65331 11.861 10.157 11.861 10.5784 11.6386L12.3669 10.7031C12.4662 10.651 12.5284 10.548 12.5284 10.4357C12.5284 10.3234 12.4662 10.2204 12.3669 10.1683L10.5675 9.22436C10.1461 9.002 9.64247 9.002 9.22105 9.22436Z",
    fill: "url(#paint1_linear_382_2516)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_382_2516",
    x1: 2.47413,
    y1: 9.73981,
    x2: 17.3785,
    y2: 9.73981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#71CFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AC440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_382_2516",
    x1: 2.47654,
    y1: 15.6202,
    x2: 17.3771,
    y2: 15.6202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#71CFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AC440"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFNftIcon);
export default __webpack_public_path__ + "static/media/f-nft-icon.f4a0a52c323ed1a43a896d67d5eda487.svg";
export { ForwardRef as ReactComponent };